import { Modal, Text } from "@equidefi/ui";

interface MultipleTabModalProps {
  isOpen: boolean;
}

/**
 * Blocks the investment workflow while it is open in another browser tab.
 * Intentionally cannot be dismissed — no buttons, and closing via the overlay,
 * the Escape key, or a close button is disabled — so the user must close the
 * other tabs to continue here.
 */
export const MultipleTabModal = ({ isOpen }: MultipleTabModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      title="Multiple tabs detected"
      closeOnOverlayClick={false}
      closeOnEsc={false}
      contentProps={{ sx: { ".chakra-modal__close-btn": { display: "none" } } }}>
      <Text>You can only continue an investment in one tab at a time. Close the other tabs to continue here.</Text>
    </Modal>
  );
};
